import {Grid, makeStyles, useMediaQuery} from '@material-ui/core';
import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {ConditionalSection, QuoteFormConditionalSection} from 'Quoting/components/shared/QuoteFormConditionalSection';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import {FormWrapper} from 'Quoting/components/shared/QuoteFormWrapper';
import React from 'react';
import {CheckboxInputGrid} from '../../../../shared/CheckboxInputGrid';
import {getPortabilityPaths} from '../Common/PropertyPaths';

/* Start: Additional Care Services */
export const RehabilitationUnitOrSubacuteConfinement = () => {
  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'rehabilitation-unit-subacute-confinement-row-1'},
      items: [
        {
          key: 'benefit-amount',
          element: (
            <QuoteFormElement elementType="Text" label="Benefit Amount" value={0} type="number" id={'benefit-amount'} />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'max-days-limit-per-confinement',
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Max # Days Limit (Per Confinement)"
              options={[]}
              value={''}
              id={'max-days-limit-per-confinement'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

export const SkilledNursingFacility = () => {
  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'substance-abuse-refinement-row-1'},
      items: [
        {
          key: 'benefit-amount',
          element: (
            <QuoteFormElement elementType="Text" label="Benefit Amount" value={0} type="number" id={'benefit-amount'} />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'max-days-limit-per-confinement',
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Max # Days Limit (Per Confinement)"
              options={[]}
              value={''}
              id={'max-days-limit-per-confinement'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

export const AdditionalCareServicesBlock = () => {
  const additionalCareServicesSections: ConditionalSection[] = [
    {
      Component: RehabilitationUnitOrSubacuteConfinement,
      key: 'RehabilitationUnitOrSubacuteConfinement',
      label: 'REHABILITATION UNIT OR SUBACUTE REHABILITATION UNIT CONFINEMENT',
    },
    {
      Component: SkilledNursingFacility,
      key: 'SkilledNursingFacility',
      label: 'SKILLED NURSING FACILITY',
    },
  ];

  return (
    <FormWrapper title="Additional Care Services" collapsible withSeparator>
      <QuoteFormConditionalSection sections={additionalCareServicesSections} />
    </FormWrapper>
  );
};
/* End: Additional Care Services */

/* Start: Additional Options and Benefits */

const usePortabilityStyles = makeStyles(() => ({
  portabilityGrid: (args: {isMobileView: boolean}) => ({
    minHeight: args.isMobileView ? 'auto' : '5.5rem',
  }),
}));

const Portability = () => {
  const isMobileView = !useMediaQuery((theme: any) => theme.breakpoints.up('sm'));
  const classes = usePortabilityStyles({isMobileView: isMobileView});
  const {getQuoteFieldValue} = useQuoteField();

  const portabilityPaths = getPortabilityPaths();

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'portability-row-1', className: classes.portabilityGrid},
      items: [
        {
          key: 'limitPortedCovDurationInd',
          element: (
            <QuoteFormElement
              elementType="FormControl"
              controlType="switch"
              label="Limited Ported Coverage Duration"
              checked={Boolean(getQuoteFieldValue<boolean>(portabilityPaths.limitPortedCovDurationInd))}
              id={portabilityPaths.limitPortedCovDurationInd}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'coverage-duration-months',
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Coverage Duration (Months)"
              value={getQuoteFieldValue(portabilityPaths.covDuration)}
              id={portabilityPaths.covDuration}
              disabled
              required
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return <FormRowGrid rows={rows} />;
};

export const GroupPolicyHolderFacilityRider = () => {
  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'portability-row-1'},
      items: [
        {
          key: 'percent-of-plan-benefit-amount',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="% of Plan Benefit Amount"
              id="percent-of-plan-benefit-amount"
              value={''}
            />
          ),
        },
      ],
    },
  ];

  return (
    <Grid container>
      <Grid item xs={12}>
        <FormRowGrid rows={rows} />
      </Grid>
      {Array.isArray([]) && (
        <Grid item xs={12}>
          <CheckboxInputGrid state={[]} gridLength={false} />
        </Grid>
      )}
    </Grid>
  );
};

export const WellnessTestSelection = () => {
  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'wellness-test-selection-row-1'},
      items: [
        {
          key: 'benefit-amount-per-unit-per-day',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Benefit Amount (Per Unit, Per Day)"
              value={0}
              type="number"
              id={'benefit-amount-per-unit-per-day'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return (
    <FormWrapper title="Test Selection" collapsible withSeparator>
      <Grid container>
        <Grid item xs={12}>
          <FormRowGrid rows={rows} />
        </Grid>
        {Array.isArray([]) && (
          <Grid item xs={12}>
            <CheckboxInputGrid state={[]} gridLength={false} />
          </Grid>
        )}
      </Grid>
    </FormWrapper>
  );
};

export const WellnessCategories = () => {
  const categories = [];
  return (
    <>
      {Array.isArray(categories) &&
        categories.map(category => (
          <FormWrapper title={category.name} collapsible withSeparator key={category.id}>
            <Grid container>
              <Grid item xs={6}>
                <QuoteFormElement
                  elementType="Text"
                  label="Benefit Amount (Per Unit, Per Day)"
                  value={category.benefitAmountPerUnitPerDay}
                  type="number"
                  id={'benefit-amount-per-unit-per-day'}
                />
              </Grid>
              {Array.isArray([]) && (
                <Grid item xs={12}>
                  <CheckboxInputGrid state={[]} gridLength={false} />
                </Grid>
              )}
            </Grid>
          </FormWrapper>
        ))}
    </>
  );
};

export const Wellness = () => {
  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'wellness-row-1'},
      items: [
        {
          key: 'type-of-wellness',
          element: (
            <QuoteFormElement
              elementType="Select"
              label="Type of Wellness"
              options={[]}
              value={''}
              id={'type-of-wellness'}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: 'wellness-num-of-units',
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Wellness # of Units"
              type="number"
              id={'wellness-num-of-units'}
              value={0}
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'wellness-row-2'},
      items: [
        {
          key: 'time-period',
          element: (
            <QuoteFormElement elementType="Select" label="Time Period" options={[]} value={''} id={'time-period'} />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];

  return (
    <div>
      <FormRowGrid rows={rows} />
      {true ? <WellnessTestSelection /> : <WellnessCategories />}
    </div>
  );
};

export const HIAdditionalOptionsandBenefitsGIM2Block = () => {
  const {getQuoteFieldValue} = useQuoteField();

  const portabilityPaths = getPortabilityPaths();
  const additionalOptionsandBenefits: ConditionalSection[] = [
    {
      Component: Portability,
      key: 'Portability',
      label: 'Portability',
      disabled: true,
      isApplied: Boolean(getQuoteFieldValue(portabilityPaths.isPortabilityApplied)),
    },
    {
      Component: Wellness,
      key: 'Wellness',
      label: 'Wellness',
      hidden: true,
      disabled: true,
    },
    {
      Component: GroupPolicyHolderFacilityRider,
      key: 'GroupPolicyHolderFacilityRider',
      label: 'Group Policy Holder Facility Rider',
      hidden: true,
      disabled: true,
    },
  ];

  return (
    <FormWrapper title="Additional Options and Benefits" collapsible withSeparator>
      <QuoteFormConditionalSection sections={additionalOptionsandBenefits} />
    </FormWrapper>
  );
};
/* End: Additional Options and Benefits */
